import { observable, action, computed } from "mobx";

class Position {
  @observable id;

  @observable rotation;

  constructor({ id = null, rotation = { x: 0, y: 0, z: 0 } }) {
    this.id = id;
    this.rotation = rotation;
  }

  @computed
  get hash() {
    return `${this.id}_${this.rotation.x}_${this.rotation.y}_${this.rotation.z}`;
  }
}

class JumpToView {
  @observable name;

  @observable position;

  @observable thumbnail;

  @observable isAdded;

  constructor({ name, position, thumbnail, isAdded = false }) {
    this.name = name;
    this.position = new Position(position);
    this.thumbnail = thumbnail;
    this.isAdded = isAdded;
  }

  @action
  setIsAdded(isAdded) {
    this.isAdded = isAdded;
  }

  @computed
  get id() {
    return this.position.hash;
  }
}

export default JumpToView;
